// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"2eecbc98","61":"5bd7dfc2","138":"1344983a","310":"31ae689e","601":"a06bef08","901":"c92f824c","904":"56e37da3","939":"883624d0"}[chunkId] + ".chunk.css";
};